module.exports = __webpack_public_path__ + "static/media/mm.1c87edc8.svg";